import React, { Fragment, useContext } from 'react';
import retry from "async-retry"
import { Alert, Card, ProgressBar, Accordion } from "react-bootstrap"
import { TextField } from '@mui/material';

import Constants from '../config.js'
import { Row } from "../components/Row";
import { AppLoadContext, ReloadButton } from "../App.js"
import { Spaces } from "../components/Spaces";
import { getLog } from '../helpers/helpers.js';
import { Loader } from '../components/Loader.js';
import RunContext from '../Contexts/RunContext.js';
import { Slide, CLIENT_MODE } from "../display_wallet.js"
import { UserContext } from "../Contexts/UserContext/UserContext.js";
import ClickToOpenCardDark from '../components/ClickToOpenCardDark.js';
import { translateErrorToJSXMessage } from "../translateErrorToJSXMessage.js";
import { SlidePopup, TextCopyQR } from '../components/WithPopup/TextCopyQR.js';
import { ButtonPrimary, ButtonSecondaryOutlined, ButtonPrimaryOutlined } from '../components/Buttons.js';
import SwitchSlider from '../components/SwitchSlider.js';
import useLog from '../hooks/useLog.js';

// TODO recoder en composant fonctionnel ? mais pas urgent


const ButtonParam = ({ children, onClick, style, ...otherProps }) => {
	return (
		<ButtonPrimary
			onClick={onClick}
			style={{ borderRadius: "100px", padding: "10px 20px", ...style }}  // width: "100%", 
			{...otherProps}
		>
			{children}
		</ButtonPrimary >
	)
}


/**
 * used to inject multiple contexts as props
 */
const Slide_Settings = (props) => {
	const runContext = useContext(RunContext)
	const appLoadContext = useContext(AppLoadContext)
	const userContext = useContext(UserContext)

	return (
		<Slide_Settings_inner userContext={userContext} runContext={runContext} appLoadContext={appLoadContext} {...props} />
	)
}

export default Slide_Settings


// TODO TURN THIS INTO A FUNCTIONAL COMPONENT
class Slide_Settings_inner extends React.PureComponent {

	// inject UserContext in this.context
	static contextType = UserContext

	constructor(props) {
		super(props)
		this.classname = "Slide_Settings: "

		this.userContext = props.userContext
		this.runContext = props.runContext
		this.run = null

		this.appLoadContext = props.appLoadContext

		this.state = {
			showmnemonic: false,
			showmnemonic_timeleft: 0, // leave at 0 here for init
			tokenorigin: "",
			firewallActivated: true,
		}
		this.showmnemonic_timeshow = 20 * 1000 // in ms

		this.handleChangeTokenOrigin = this.handleChangeTokenOrigin.bind(this)
		this.clickedUpdateTokenOrigin = this.clickedUpdateTokenOrigin.bind(this)
		this.handleClick_showmnemonic = this.handleClick_showmnemonic.bind(this)
		this.handleClick_clearHistoryCache = this.handleClick_clearHistoryCache.bind(this)
		this.reduce_timeleft = this.reduce_timeleft.bind(this)
		this.changeFireWall = this.changeFireWall.bind(this)
		this.clicked_update_disable_all_sync = this.clicked_update_disable_all_sync.bind(this)
		// doesn't work
		// this.turn_off_run_trust_security = this.turn_off_run_trust_security.bind(this)
		this.errorjsx = ""
	}

	changeFireWall() {
		if (!this.run) {
			window.alert("wait for wallet to have fully loaded before doing this action")
			return
		}

		if (this.state.firewallActivated) {
			// turn firewall off
			window.alert("Cliquez OK pour désactiver le pare-feu")
			this.run.trust("*")
		} else {
			// turn firewall back on
			window.alert("Cliquez OK pour activer le pare-feu")
			// this.run.trust([])
			this.run.trust("state")
		}
		this.setState({ firewallActivated: !this.state.firewallActivated })

		// call wallet refresh
		this.appLoadContext.reload()
	}


	clickedUpdateTokenOrigin(event) {
		event.preventDefault()

		if (!this.run) {
			window.alert("wait for wallet to have fully loaded before doing this action")
			return
		}

		window.alert(
			"Cliquez OK pour charger le nouveau contrat, "
			+ "attention cette opération peut prendre plusieurs minutes:"
		)
		this.context.update_contract_origin_and_reload(this.state.tokenorigin)
	}

	clicked_update_disable_all_sync(event) {

		if (!this.run) {
			window.alert("wait for wallet to have fully loaded before doing this action")
			return
		}

		let newval = !this.context.disable_all_sync
		// TODO fix below line, alert() doesn't actually allow to know what the user input was, so use a confirm()
		// window.alert(newval==true?"Désactiver?":"Activer?")
		this.context.update_disable_all_sync(newval)
	}


	handleChangeTokenOrigin(event) {

		if (!this.run) {
			window.alert("wait for wallet to have fully loaded before doing this action")
			return
		}

		this.errorjsx = ""
		//var targetid = event.target.id
		this.setState({ tokenorigin: event.target.value })
	}

	async handleClick_showmnemonic() {
		const function_id = "Display_Wallet: handleClick_showmnemonic(): "
		const log = getLog(function_id)
		//
		// ASK FOR CONFIRMATION
		let abort = true
		let message = "⚠️ ETES VOUS SUR ? PERSONNE DERRIERE VOUS ? ⚠️"
		if (!Constants.IS_WEB_BUILD) {  // for electron app
			const options = {
				type: 'question',
				buttons: ['Continue', 'Cancel'],
				defaultId: 1,
				title: 'Warning',
				message: message
			};
			await window.electron.openDialogShowMessageBox(options).then(async (resdata) => {
				const response = resdata.response
				log("response = " + response);
				if (response === 0) {
					abort = false
				}
			});
		} else {  // for web
			let res = window.confirm(message);
			if (res === true) abort = false
		}
		if (abort) {
			return
		}
		// ACTION CONFIRMED
		this.setState({
			showmnemonic: true,
			showmnemonic_timeleft: this.showmnemonic_timeshow,
		})
		setTimeout(this.reduce_timeleft, 50);
	}


	async reduce_timeleft(last_timestamp = null) {

		if (last_timestamp == null)
			last_timestamp = Date.now()

		// log("display_wallet: parameters: showmnemonic=",this.state.showmnemonic,
		// 			", showmnemonic_timeleft=",this.state.showmnemonic_timeleft)

		if (this.state.showmnemonic_timeleft < 0) {
			this.setState({ showmnemonic: false })
			return
		}
		this.setState({
			showmnemonic_timeleft: this.state.showmnemonic_timeleft - (Date.now() - last_timestamp)
		})
		last_timestamp = Date.now()
		setTimeout(() => {
			this.reduce_timeleft(last_timestamp)
		}, 50)
	}

	async componentDidMount() {
		const function_id = this.classname + "componentDidMount(): "

		this.setState({ tokenorigin: this.context.tokenorigin })

		// retry loop with exponential backoff
		await retry(async () => {
			// if anything throws, we retry
			console.log(function_id + "this.context.get_run_asyncf()...")
			this.run = await this.runContext.get_run_asyncf()
			console.log(function_id + " successfully got run instance from context.")
		}, {
			retries: 3,
			minTimeout: 500,  // in ms
			maxTimeout: 5000,   // in ms
			factor: 2,  // exponential-backoff
		})
		this.forceUpdate()
	}

	// doesn't work
	// async turn_off_run_trust_security(){
	// 	const function_id = this.classname+"turn_off_run_trust_security(): "
	// 	let log=getLog(function_id)

	// 	if(!this.run){
	// 		window.alert("Veuillez attendre la fin du chargement avant.")
	// 		return
	// 	}
	// 	log("called")
	// 	await this.run.trust('*')
	// 	window.alert("Parefeu désactivé, le wallet va recharger, cela peu prendre plus de temps que d'habitude.")
	// 	this.context.reload_wallet() // DONT AWAIT THIS ONE!
	// }


	async handleClick_clearHistoryCache() {
		const function_id = this.classname + "handleClick_clearHistoryCache(): "

		let message = "⚠️ Effacer le cache nécessitera de reconstruire tout l'historique depuis la blockchain, cela peut prendre un certain temps ⚠️"

		let didconfirm = false
		if (!Constants.IS_WEB_BUILD)  // electron app
		{
			let options = {
				title: "Warning",
				message: message,
				buttons: ['Continue', 'Cancel'],
				defaultId: 1,
			}
			await window.electron.openDialogShowMessageBox(options).then((resdata) => {
				console.log(function_id + " messageBox-> resdata : ", resdata)
				if (resdata.response === 0) didconfirm = true
			});
		}
		else {  // web
			didconfirm = window.confirm(message);
		}
		if (didconfirm === false) return;  // abort if user clicked no

		try {
			console.log(function_id + " clearing cache...")
			await this.context.clearCache()
			// also reset the BSV in-memory history cache (raw + enriched)
			// so the BSV History page refetches everything from scratch
			this.context.reset_cache_history_bsv()
		}
		catch (error) {
			console.error(function_id, error)
			this.errorjsx =
				// pas de reload mais un bouton fermer ici, sinon pas de sens
				//   car on veut pouvoir modifier les params après une erreur !
				<SlidePopup
					onButtonClick={() => { this.errorjsx = ""; this.forceUpdate() }}
				>
					{translateErrorToJSXMessage(error)}
				</SlidePopup>
			this.forceUpdate()
		}
		this.context.reload_wallet()  // DONT AWAIT THIS ONE!
	}

	render() {

		let showerror = ""
		if (this.errorjsx) {
			showerror = <div><br />{this.errorjsx}<br /></div>
		}

		let dev_mode = false
		if (!window.electron || !window.electron.hasShell()) dev_mode = true

		let log_path_file = this.props.logpath
		let log_path_folder = ""
		if (log_path_file) {
			if (log_path_file.includes("\\")) {
				log_path_folder = log_path_file.substring(0, log_path_file.lastIndexOf("\\"))
			}
			else {
				log_path_folder = log_path_file.substring(0, log_path_file.lastIndexOf("/"))
			}
		}
		// if(path.includes('/')){
		// 	path = path.split('/').slice(0,-1).join('/')
		// } else {
		// 	path = path.split('\\').slice(0,-1).join('\\')
		// }

		let jsx_logfile = null, logfile_onclick = null, logfile_text = ""
		if (!dev_mode) {
			logfile_text = "Ouvrir le dossier des logs"
			logfile_onclick = () => { window.electron.openFolderInExternalWindow(log_path_folder) }
		} else {
			logfile_text = "mode développement: pas de fichier de log"
			logfile_onclick = () => { alert("dev mode: no log file") }
		}

		jsx_logfile =
			<ButtonParam onClick={logfile_onclick}>
				{logfile_text}
			</ButtonParam>
		// <a className="submitbutton" style={{ cursor: "pointer", display: "block" }}
		// 	onClick={logfile_onclick}>
		// 	{logfile_text}
		// </a>

		let mnemonic_or_button =
			<ButtonParam onClick={this.handleClick_showmnemonic}>
				Show seed phrase
			</ButtonParam>
		// let mnemonic = <a onClick={this.handleClick_showmnemonic}
		// 	className="submitbutton" style={{ cursor: "pointer", display: "block" }}>
		// 	Afficher la phrase clé secrète
		// </a>

		let isMockWallet = this.userContext.isMockWallet || false
		if (isMockWallet) {
			mnemonic_or_button = <div>This is an example wallet, create a new wallet to show the seed phrase.</div>
		}

		// const IS_IN_PRODUCTION = (process.env.NODE_ENV === "production")
		const IS_IN_PRODUCTION = !Constants.IS_WEB_BUILD
		// format is <privkey_purse>:<privkey_owner>
		const privkeys_str = this.run ? this.run.purse.privkey + ":" + this.run.owner.privkey : null

		if (this.state.showmnemonic) {
			mnemonic_or_button =
				<div style={{ padding: "15px", textAlign: "center", border: "1px solid red" }}>
					<TextCopyQR value={this.context.get_mnemonic_or_devmode()} />
					{IS_IN_PRODUCTION ? null : <span>{privkeys_str}</span>}
				</div>
		}

		let cache_folder_path = null
		try {
			cache_folder_path = this.run.cache.get_path()
		} catch (e) { }

		let cache_folder_path_raw = null
		try {
			cache_folder_path_raw = this.run.cache.get_path_raw()
		} catch (e) { }

		let separator_color = "red"  // #d39e00 // TODO put that in global config
		let jsx_separator = <Fragment>
			<br /><br />
			<div style={{ width: "100%", borderBottom: "1px solid " + separator_color }} />
			<br /><br />
		</Fragment>

		const wallet_card_jsx = <Fragment>
			<div className="walletcard" id="menu_tab_0"
				style={{
					justifyContent: "center", display: "flex", flexDirection: "column",
					fontSize: "20px", padding: "0.6em 0.5em",
				}}>
				<div className="badge badge-light"
					style={{ padding: "1em 0em", whiteSpace: "normal", wordBreak: "break-all" }}>
					{this.context.walletname}
				</div>
			</div><br />
		</Fragment>

		const buttonsCustomStyle = {
			cursor: this.run ? "pointer" : "not-allowed",
			backgroundColor: this.run ? "" : "grey",
			pointerEvents: this.run ? "auto" : "none"
		}

		const ReloadWalletButton = () => {
			const appLoadContext = useContext(AppLoadContext)
			const log = useLog("ReloadWalletButton")
			const isloading = appLoadContext.isloading
			log("RELOAD BUTTON isloading :", isloading)
			return (
				<ButtonParam
					onClick={appLoadContext.reload}
					disabled={isloading}
					style={{
						backgroundColor: isloading ? 'grey' : '',
						cursor: isloading ? 'not-allowed' : 'pointer',
						margin: "0 auto",
					}}
				>
					Reload Wallet &nbsp;
					<i className={
						"fas fa-sync " + (isloading ? "fa-spin" : "")
					} />
				</ButtonParam>
			)
		}

		return (
			<Slide num={this.props.num}>
				<h1><i className="fas fa-cog" /><Spaces count="3" />
					Wallet Settings
				</h1>
				<br />

				{showerror}

				{wallet_card_jsx}

				<br />
				<ClickToOpenCardDark title="Secret Backup Phrase (seed)">
					<center><br />
						<Alert variant="danger" style={{ fontWeight: "bold", fontSize: "18px", margin: "0" }}>
							<i className="fa fa-info-circle" style={{ fontSize: "20px" }} /> &nbsp;
							{Constants.SEED_INFO}
						</Alert><br />

						<Alert variant="danger" style={{ fontWeight: "bold", fontSize: "18px", margin: "0" }}>
							<i className="fa fa-info-circle" style={{ fontSize: "20px" }} /> &nbsp;
							{Constants.SEED_INFO_MORE}
						</Alert><br />

						<div style={{ width: "100%" }}>
							{mnemonic_or_button}

							{this.state.showmnemonic ?
								<ProgressBar animated striped variant="danger" style={{ height: "0.5em", borderRadius: "0" }}
									now={this.state.showmnemonic_timeleft / this.showmnemonic_timeshow * 100} />
								: null}
						</div>
						<br />
					</center>
				</ClickToOpenCardDark>
				<br />

				<ClickToOpenCardDark title="Device Security">
					<center><br />
						<Alert variant="info" style={{ fontSize: "16px", margin: "0" }}>
							<i className="fa fa-info-circle" style={{ fontSize: "20px" }} /> &nbsp;
							Your wallet is stored encrypted on this device. You can clear it below.
						</Alert><br />

						{this.context.has_remembered_wallet() ?
							<ButtonParam
								onClick={() => {
									this.context.clear_remembered_encrypted_wallet()
									alert("This wallet has been forgotten from this device. You will need your seed phrase or backup file to restore it after your close this tab.")
								}}
							>
								Forget this wallet on this device
							</ButtonParam>
							:
							<div style={{ color: "silver" }}>
								This wallet is not remembered on this device.
							</div>
						}
						<br />
					</center>
				</ClickToOpenCardDark>
				<br />


				<ClickToOpenCardDark title="Load a Token">
					<center><br />
						<Row>
							<TextField fullWidth
								id="outlined-basic" variant="outlined"
								label={<span>Address of a token</span>}
								value={this.state.tokenorigin ? this.state.tokenorigin : ""}
								onChange={this.handleChangeTokenOrigin}
								placeholder={""}
							/>
						</Row><br />

						<Row>
							{this.context.tokens_balance[this.context.get_selected_coin_props().tokenid] != null ?
								<ButtonParam
									onClick={this.run ? this.clickedUpdateTokenOrigin : null}
									style={buttonsCustomStyle}
								>
									{this.run ? "Charger ce token" : "Chargement..."} {this.run ? null : <Loader small black />}
								</ButtonParam>

								// <a onClick={this.clickedUpdateTokenOrigin}
								// 	className="submitbutton" style={{ cursor: "pointer" }}>
								// 	Charger ce contrat
								// </a>
								:
								<ButtonParam onClick={this.clickedUpdateTokenOrigin} style={{
									cursor: "pointer", backgroundColor: "grey", pointerEvents: "none",
								}}>
									loading... <Loader small black />
								</ButtonParam>
								// <a onClick={this.clickedUpdateTokenOrigin}
								// 	className="submitbutton" style={{
								// 		cursor: "pointer", backgroundColor: "grey", pointerEvents: "none"
								// 	}}>
								// 	chargement en cours... <Loader small black />
								// </a>
							}
						</Row>
						<br /><br />

						<span style={{ wordBreak: "break-all" }}>
							<center>

								<div style={{ color: "silver" }}>
									<i style={{ fontSize: "22px", marginRight: "10px" }} className="fa fa-info-circle" /><br />
									Delphe: f597770adc303efe702fcc1497b87703d166adc9d2a5a4cd8e92c571b2324201_o1<br />
								</div>

							</center>
						</span>
					</center>
				</ClickToOpenCardDark>
				<br />

				<ClickToOpenCardDark title="Cache">
					<center><br />						{/* <div onClick={this.handleClick_clearHistoryCache}
							className="submitbutton" style={{ cursor: "pointer", width: "100%" }}>
							Effacer le cache de l'historique des transactions
						</div>
						<br /> */}
						<ButtonParam onClick={this.handleClick_clearHistoryCache} style={buttonsCustomStyle}>
							Erase the cache of transaction history
						</ButtonParam>
						<br /><br />

						{cache_folder_path ?
							<><ButtonParam
								onClick={() => { window.electron.openFolderInExternalWindow(cache_folder_path) }}
							>
								Open cache folder
							</ButtonParam><br /><br /></>
							:
							(Constants.IS_WEB_BUILD ? null :
								<><ButtonParam
									style={{ backgroundColor: "grey", pointerEvents: "none", }}
									onClick={() => { window.electron.openFolderInExternalWindow(cache_folder_path) }}
								>
									(dev mode: no cache folder)
								</ButtonParam><br /><br /></>
							)
						}

						{Constants.IS_WEB_BUILD ? null :
							<span style={{ wordBreak: "break-all" }}>
								Cache File: {cache_folder_path_raw ? cache_folder_path_raw : "(dev mode: no cache folder)"}
							</span>
						}
						<br />
					</center>
				</ClickToOpenCardDark>
				<br />

				{Constants.IS_WEB_BUILD ? null :
					<ClickToOpenCardDark title="Logs">
						<center><br />
							<div style={{ margin: "0 auto", textAlign: "center", width: "100%" }}>
								{jsx_logfile}
							</div>
							<br />
							<span style={{ wordBreak: "break-all" }}>
								Log File: {log_path_file ? log_path_file : "(dev mode: no cache folder)"}
							</span>
							<br />
						</center>
						<br />
					</ClickToOpenCardDark>
				}

				{Constants.IS_WEB_BUILD ? null :
					<ClickToOpenCardDark title="Blockchain Synchronization">
						<center><br />
							<div className="centered">
								En désactivant le bouton ci-dessous, vous pouvez désactiver les synchronisations.
								Votre wallet s'affichera uniquement à partir du cache local.
								Ce mode peut être utile si le wallet n'arrive pas à se connecter aux noeuds,
								car il permet malgré tout de continuer à pouvoir envoyer des transactions.
								<br /><br /><br />

								<Row style={{ display: "inline-block" }}>
									<SwitchSlider
										onChange={this.clicked_update_disable_all_sync}
										checked={!this.context.disable_all_sync}
									/>
									&nbsp;<i>Activate synchronizations</i>
								</Row>
								<br />
							</div>
						</center>
						<br />
					</ClickToOpenCardDark>
				}

				{/* --- params only for admins --- */}

				{CLIENT_MODE ? null : <Fragment>
					<ClickToOpenCardDark title="Firewall">
						<center><br />
							<div className="centered">
								Le parefeu protège votre application contre des envois de code malveillant sur votre adresse delphe.
								Il est hautement recommandé de le garder activé pendant que nous travaillons à renforcer la sécurité.
								<br /><br /><br />

								<Row style={{ display: "inline-block" }}>
									<SwitchSlider
										onChange={this.changeFireWall}
										checked={this.state.firewallActivated}
										style={buttonsCustomStyle}
									/>
									&nbsp;<i>Activate Firewall</i>
								</Row>
							</div>
						</center>
					</ClickToOpenCardDark>
					<br />
				</Fragment>
				}


				{/* // this is not enough to trust('*') & reload, probably need to also erase all ban:// from cache first ?
				{jsx_separator}
					
				<Row>
					<h1>Sécurité du cache (parefeu, fonctionnalité avancée)</h1>
				</Row><br/>
				
				<Row>
					<div style={{margin: "0 auto", textAlign:"center", width:"100%"}}>
						Désactiver le parefeu du cache n'est pas recommandé.&nbsp;
						Cependant cela peut régler certains problèmes de type "Sync the jig to assign it in a transaction",
						mais ouvre votre wallet à des envois qui peuvent faire crasher l'application.
						Noter bien le chemin du fichier de cache pour pouvoir le supprimer manuellement si cela arrivait:
						<br/>
						<span style={{wordBreak: "break-all"}}>
							{cache_folder_path_raw?cache_folder_path_raw:"(dev mode: no cache folder)"}
						</span>
					</div>
				</Row><br/>

				<Row>
				<a onClick={this.turn_off_run_trust_security}
					id="test" className="submitbutton" style={{cursor:"pointer"}}>
					Désactiver le parefeu du cache (non recommandé)
				</a>
				</Row><br/> */}

				<br />

				<center>
					<ReloadWalletButton />
				</center>
				<br />

				<center>
					<ButtonPrimaryOutlined
						// onClick={this.props.onClickedReportBug}
						// onClick={() => { window.electron.openUrlInExternalWindow("https://t.me/+xvrPdKLAkU80ZDg8") }}
						onClick={() => { window.open("https://t.me/+xvrPdKLAkU80ZDg8", "_blank") }}
						style={{ borderRadius: "10em", padding: "1px 15px" }}
					>
						Report a bug or get help
					</ButtonPrimaryOutlined>
				</center>
				<br />

				<div className="centered" style={{ color: "lightslategrey", }}>
					version: {Constants.APP_VERSION}
				</div>
				<br />


			</Slide>
		)
	}
}
